/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_SoftwareInputs */

const en_field_software = /** @type {(inputs: Field_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Required Software`)
};

const es_field_software = /** @type {(inputs: Field_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software necesario`)
};

const fr_field_software = /** @type {(inputs: Field_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logiciel requis`)
};

const de_field_software = /** @type {(inputs: Field_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benötigte Software`)
};

const ja_field_software = /** @type {(inputs: Field_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`必要なソフトウェア`)
};

const zh_field_software = /** @type {(inputs: Field_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所需软件`)
};

const ar_field_software = /** @type {(inputs: Field_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البرنامج المطلوب`)
};

const id_field_software = /** @type {(inputs: Field_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perangkat Lunak Diperlukan`)
};

const it_field_software = /** @type {(inputs: Field_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software Richiesto`)
};

const ru_field_software = /** @type {(inputs: Field_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Необходимое ПО`)
};

const pt_field_software = /** @type {(inputs: Field_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Software Necessário`)
};

const ko_field_software = /** @type {(inputs: Field_SoftwareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`필요한 소프트웨어`)
};

/**
* | output |
* | --- |
* | "Required Software" |
*
* @param {Field_SoftwareInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_software = /** @type {((inputs?: Field_SoftwareInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_SoftwareInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_software(inputs)
	if (locale === "es") return es_field_software(inputs)
	if (locale === "fr") return fr_field_software(inputs)
	if (locale === "de") return de_field_software(inputs)
	if (locale === "ja") return ja_field_software(inputs)
	if (locale === "zh") return zh_field_software(inputs)
	if (locale === "ar") return ar_field_software(inputs)
	if (locale === "id") return id_field_software(inputs)
	if (locale === "it") return it_field_software(inputs)
	if (locale === "ru") return ru_field_software(inputs)
	if (locale === "pt") return pt_field_software(inputs)
	return ko_field_software(inputs)
});